module.exports = __webpack_public_path__ + "img/company_logo.4b754742.svg";